















import { computed, defineComponent } from '@vue/composition-api';
import { useStore } from '@/store';
import PrintLink from '@/components/Navigation/PrintLink.vue';
import UpdatesLink from '@/components/Navigation/UpdatesLink.vue';

export default defineComponent({
    name: 'CommonHeader',
    components: { UpdatesLink, PrintLink },
    setup () {
        const store = useStore();
        const subtitle = computed(() => {
            const amount = store.state.items.length;
            return `${amount} Vehicle${amount === 1 ? '' : 's'}`;
        });
        return { subtitle };
    }
});
